import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Chest } from './Illustrations/Chest';
import { StatusPage } from './StatusPage';

export interface UnauthorizedProps {
	link?: ReactNode;
}

export const Unauthorized = ({ link }: UnauthorizedProps) => {
	const { t } = useTranslation('monarch');

	return (
		<StatusPage
			graphic={<Chest title={t('status.locked_image_title')} />}
			heading={t('status.unauthorized_title')}
			subheading={t('status.unauthorized_description')}
			status={401}
			link={link}
		/>
	);
};
